module.exports = __webpack_public_path__ + "img/79.8.TSS.e1a31502.png";